import React from "react";
import { useNavigate, Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import "../styles/UserProfile.css";

const UserProfile = ({ userData, setUserData }) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (!userData) {
      navigate("/login");
    }
  }, [userData, navigate]);

  if (!userData) {
    return null;
  }

  const handleLogout = () => {
    localStorage.removeItem("user");
    setUserData(null);
    navigate("/login");
  };

  const joinDate = userData.created_at
    ? new Date(userData.created_at).toLocaleDateString("en-IN", {
        year: "numeric",
        month: "long",
        day: "numeric",
      })
    : "N/A";

  const initial = userData.username ? userData.username.charAt(0).toUpperCase() : "U";

  return (
    <div className="up-page">
      {/* Hero banner */}
      <div className="up-hero">
        <div className="up-hero-content">
          <div className="up-avatar">{initial}</div>
          <h1 className="up-name">{userData.username}</h1>
          <span className="up-badge">
            <Icon icon="mdi:check-decagram" width="16" />
            Verified Member
          </span>
        </div>
      </div>

      <div className="up-body">
        {/* Info cards */}
        <div className="up-info-grid">
          <div className="up-info-card">
            <div className="up-info-icon">
              <Icon icon="mdi:email-outline" width="22" />
            </div>
            <div className="up-info-text">
              <span className="up-info-label">Email Address</span>
              <span className="up-info-value">{userData.email || "Not provided"}</span>
            </div>
          </div>

          <div className="up-info-card">
            <div className="up-info-icon">
              <Icon icon="mdi:phone-outline" width="22" />
            </div>
            <div className="up-info-text">
              <span className="up-info-label">Phone Number</span>
              <span className="up-info-value">{userData.phone || "Not provided"}</span>
            </div>
          </div>

          <div className="up-info-card">
            <div className="up-info-icon">
              <Icon icon="mdi:map-marker-outline" width="22" />
            </div>
            <div className="up-info-text">
              <span className="up-info-label">Address</span>
              <span className="up-info-value">{userData.address || "Not provided"}</span>
            </div>
          </div>

          <div className="up-info-card">
            <div className="up-info-icon">
              <Icon icon="mdi:calendar-outline" width="22" />
            </div>
            <div className="up-info-text">
              <span className="up-info-label">Member Since</span>
              <span className="up-info-value">{joinDate}</span>
            </div>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="up-actions-section">
          <h2 className="up-section-title">Quick Actions</h2>
          <div className="up-actions-grid">
            <Link to="/orders" className="up-action-card">
              <div className="up-action-icon orders-icon">
                <Icon icon="mdi:receipt-text-outline" width="28" />
              </div>
              <span className="up-action-label">My Orders</span>
              <span className="up-action-desc">View order history</span>
              <Icon icon="mdi:chevron-right" className="up-action-arrow" width="20" />
            </Link>

            <Link to="/menu" className="up-action-card">
              <div className="up-action-icon menu-icon">
                <Icon icon="mdi:food-outline" width="28" />
              </div>
              <span className="up-action-label">Browse Menu</span>
              <span className="up-action-desc">Discover new dishes</span>
              <Icon icon="mdi:chevron-right" className="up-action-arrow" width="20" />
            </Link>
          </div>
        </div>

        {/* Logout */}
        <button className="up-logout-btn" onClick={handleLogout}>
          <Icon icon="mdi:logout" width="20" />
          Sign Out
        </button>
      </div>
    </div>
  );
};

export default UserProfile;
